document.addEventListener('DOMContentLoaded', function () {
  const vehicleData = JSON.parse(document.getElementById('vehicle-information').textContent)
  const container = document.querySelector('.build__series_items')
  const spinner = document.querySelector('.spinner')
  let currentIndex = container.children.length // Start from the number of initially loaded items
  const loadMoreItems = 4 // Number of items to load on each scroll

  function appendItems (count) {
    const fragment = document.createDocumentFragment()
    for (let i = currentIndex; i < currentIndex + count && i < vehicleData.length; i++) {
      const item = vehicleData[i]
      const itemElement = document.createElement('div')
      itemElement.classList.add('build__series_item')
      itemElement.innerHTML = `
        <div class="build__series_video">
          <iframe
            src="${item.video}"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="build__series_details">
          <div class="build__series_item_title">${item.title}</div>
          <div class="build__series_description">${item.description}</div>
          <a href="${item.url}" target="_blank" class="build__series_button">${item.button}</a>
        </div>
      `
      fragment.appendChild(itemElement)
    }
    container.appendChild(fragment)
    currentIndex += count
    spinner.classList.remove('active') // Hide spinner after appending items

    // Check if all items are loaded
    if (currentIndex >= vehicleData.length) {
      window.removeEventListener('scroll', onScroll)
    }
  }

  function onScroll () {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
      spinner.classList.add('active') // Show spinner while fetching items
      appendItems(loadMoreItems)
    }
  }

  window.addEventListener('scroll', onScroll)
})
